<template lang="html">
  <v-layout pa-3 mb-2>
    <v-flex xs12 sm12 md12 lg6>
      <v-card
        style="padding: 20px; margin: 20px; overflow-y: auto;"
        height="800px"
        outlined
      >
      <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg6>
          <v-text-field label="Website name" v-model="website.name"></v-text-field>
          <label class="label">Main color</label>
          <sketch-picker
          @input="updateValue"
          :value="`#${website.mainColor}`"
          ></sketch-picker>
          <v-text-field label="Title" v-model="website.title"></v-text-field>
          <v-text-field label="Main question" v-model="website.mainQuestion"></v-text-field>
          <v-text-field label="Question 1" v-model="website.question1"></v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md12 lg6>
          <v-text-field label="Question 2" v-model="website.question2"></v-text-field>
          <v-text-field label="Question 3" v-model="website.question3"></v-text-field>
          <v-text-field label="Start text" v-model="website.findOut"></v-text-field>
          <v-text-field label="Description" v-model="website.description"></v-text-field>
          <v-text-field label="Button text" v-model="website.button"></v-text-field>
          <v-text-field label="Thank you page url" v-model="website.thankYouUrl"></v-text-field>
          <v-text-field label="Data policy url" v-model="website.dataPolicy"></v-text-field>
          <v-text-field label="Data policy text" v-model="website.dataPolicyText"></v-text-field>
          <v-combobox
            v-model="website.emails"
            :items="defaultEmails"
            label="Target emails"
            multiple
            chips
          ></v-combobox>
        </v-flex>
      </v-layout>
        </v-container>
      </v-card>
      <div class="row" style="text-align: end">
        <v-btn @click="_saveWebsite_" color="rgb(117, 233, 114)">Anmelden</v-btn>
      </div>
    </v-flex>
    <v-flex xs12 sm12 md12 lg6>
      <v-card
      style="padding: 20px; margin: 20px;"
      height="900px"
      outlined
      >
        <iframe :key="ifameSrc" width="100%" height="100%" :src="ifameSrc"></iframe>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>

import { Sketch } from 'vue-color'
import toast from '../../error/toast'
import { langFile } from '../../config/language'

export default {
  data () {
    return {
      iframe: 0,
      defaultEmails: [],
      website: {
        name: '',
        mainColor: 'ffffff',
        title: '',
        dataPolicy: '',
        mainQuestion: '',
        question1: '',
        question2: '',
        question3: '',
        findOut: '',
        description: '',
        button: '',
        emails: [],
        thankYouUrl: '',
        dataPolicyText: ''
      }
    }
  },
  created () {
    if (this.$route.params.id) {
      this._findWebsite_()
    }
  },
  methods: {
    _getParam_(val) {
      return !!val ? encodeURIComponent(val) : '-'
    },
    updateValue (val) {
      this.website.mainColor = val.hex.substr(1)
    },
    _findWebsite_ () {
      this.$httpClient.post(`websites/find.php?id=${this.$route.params.id}`)
      .then(resp => {
        resp.data.emails = resp.data.emails.split(',').filter(mail => !!mail)
        this.website = resp.data
      })
    },
    _saveWebsite_ () {
      this.website.emails = this.website.emails.join(',')
      if (this.$route.params.id) {
        this.$httpClient.post(`websites/update.php`, this.website)
        .then(() => {
          toast.success(langFile.muvelet_sikeresen_vegrehajtva)
          this.$router.push('/websites')
        })
      } else {
        this.$httpClient.post('websites/create.php', this.website)
        .then(() =>  {
          toast.success(langFile.muvelet_sikeresen_vegrehajtva)
          this.$router.push('/websites')
        })
      }
    }
  },
  computed: {
    ifameSrc () {
      const paramArray = [
        this._getParam_(this.website.mainColor),
        this._getParam_(this.website.title),
        this._getParam_(this.website.mainQuestion),
        this._getParam_(this.website.question1),
        this._getParam_(this.website.question2),
        this._getParam_(this.website.question3),
        this._getParam_(this.website.findOut),
        this._getParam_(this.website.description),
        this._getParam_(this.website.button),
        this._getParam_(this.website.dataPolicy),
        this._getParam_(this.website.dataPolicyText)
      ]
      const params = paramArray.join('/')
      // return `http://localhost:8080/#/0/${params}`
      return `https://embed.denke-plus.de/#/0/${params}`
    }
  },
  components: {
    'sketch-picker': Sketch
  }
}
</script>

<style lang="css">
.vc-sketch {
  width: auto !important;
  margin-right: 10px;
}
.label{
  color: rgb(129, 129, 129);
}
</style>
